const Config = {
    defaultPath: '/sg/login',
    basename: '',
    layout: 'horizontal',
    subLayout: '',
    collapseMenu: false,
    layoutType: 'menu-light',
    headerBackColor: 'background-dark',
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: false,
    boxLayout: false,
};
export default Config;
